<template>
  <div>
    <Card>
      <TablePaginate :columns="columns"
                     :data="score_product_change_records"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <!-- <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           title="新增积分商品">
      <Form ref="score_product"
            :model="score_product_change_record"
            :label-width="80">
        <Form-item label="商品名"
                   prop="name">
          <Input type="text"
                 v-model="score_product_change_record.name" />
        </Form-item>
        <Form-item label="价格"
                   prop="price">
          <Input type="number"
                 v-model="score_product_change_record.price" />
        </Form-item>
        <Form-item label="积分"
                   prop="score">
          <Input type="number"
                 v-model="score_product_change_record.score" />
        </Form-item>
      </Form>
    </Modal> -->
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate,
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_score_product_change_records_index_924'),
          key: 'score_product_name',
          render: (h, params) => {
            const children = []
            children.push(h('span', params.row.score_product_name || params.row.summary))
            return h('div', children)
          }
        },
        {
          title: i18n.t('pages_customers_index_338'),
          key: 'score_product_score',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(h('span', params.row.score_product_score || params.row.used_score))
            return h('div', children)
          }
        },
        {
          title: i18n.t('pages_score_product_change_records_index_925'),
          align: 'center',
          key: 'fresh_customer_mobile',
          width: 150,
        },
        {
          align: 'center',
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at_str',
          width: 200,
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapState('score_product_change_record', ['score_product_change_record', 'score_product_change_records', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('score_product_change_record', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('score_product_change_record', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.score_product_change_record)
      } else if (this.formType === 'new') {
        await this.create(this.score_product_change_record)
      }
      this.modalShow = false
    }
  }
}
</script>
